export default "/images/br-div.svg?f3ac953b708cb757820199b8ad01bd0c";